export const FIND_TABLE_CONFIGS_SUCCESS = 'FIND_TABLE_CONFIGS_SUCCESS';

export const findTableConfigsSuccess = (tableEntry) => ({
    type: FIND_TABLE_CONFIGS_SUCCESS,
    payload: {
        tableEntry,
    },
});
